(() => {
  const topNavToggle = document.getElementById('topNavToggle');
  const topNav = document.getElementById('topNavCollapse');
  const topNavMenuItems = topNav.querySelectorAll('.menu-item a');
  let keyboardEscapeListener;
  let keyboardFirstItemListener;
  let keyboardLastItemListener;
  const openTopNav = () => {
    topNav.classList.add('open');
    topNavToggle.setAttribute('aria-label', 'Close Mobile Menu');
    if (topNavMenuItems.length > 0) {
      // Focus on first menu item
      topNavMenuItems[0].focus();
      // Add event listeners for keyboard navigation
      topNavMenuItems[0].addEventListener('keydown', keyboardFirstItemListener);
      topNavMenuItems[topNavMenuItems.length - 1].addEventListener(
        'keydown',
        keyboardLastItemListener,
      );
    }
    topNavMenuItems.forEach((menuItem) => {
      menuItem.addEventListener('keydown', keyboardEscapeListener);
    });
  };

  const closeTopNav = () => {
    topNav.classList.remove('open');
    topNavToggle.setAttribute('aria-label', 'Open Mobile Menu');
    // Remove keyboard navigation event listeners
    topNavMenuItems.forEach((menuItem) => {
      menuItem.removeEventListener('keydown', keyboardEscapeListener);
    });
    if (topNavMenuItems.length > 0) {
      topNavMenuItems[0].removeEventListener(
        'keydown',
        keyboardFirstItemListener,
      );
      topNavMenuItems[topNavMenuItems.length - 1].removeEventListener(
        'keydown',
        keyboardLastItemListener,
      );
    }
  };

  // Close mobile menu if escape key is pressed
  keyboardEscapeListener = (e) => {
    if (e.key === 'Escape' && topNav.classList.contains('open')) {
      closeTopNav();
      // Focus on toggle button
      topNavToggle.focus();
    }
  };

  // Close mobile menu if reverse tab out of first menu item
  keyboardFirstItemListener = (e) => {
    if (e.key === 'Tab' && e.shiftKey && topNav.classList.contains('open')) {
      closeTopNav();
    }
  };

  // Close mobile menu if tab out of last menu item
  keyboardLastItemListener = (e) => {
    if (e.key === 'Tab' && topNav.classList.contains('open')) {
      closeTopNav();
    }
  };

  topNavToggle.addEventListener('click', () => {
    if (topNav.classList.contains('open')) {
      closeTopNav();
    } else {
      openTopNav();
    }
  });
})();
